import { Link } from 'react-router-dom';
import { getCategoryName, formatCount, formatDate } from '@/lib/content';
import type { Article } from '@/types/content';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/article/${article.id}`} className="block">
        <div className="h-44 w-full overflow-hidden bg-background-100 md:h-48">
          <img
            src={article.cover}
            alt={`${article.title} 相关插画`}
            title={`${article.title} - 猎奇吃瓜`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="mb-2 flex items-center gap-2">
          <Link
            to={`/category/${article.category}`}
            className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-800 transition-colors hover:bg-secondary-200"
          >
            {getCategoryName(article.category)}
          </Link>
          <span className="text-xs text-foreground-400">{formatDate(article.date)}</span>
        </div>
        <h3 className="text-base font-bold leading-snug text-foreground-950">
          <Link to={`/article/${article.id}`} className="transition-colors hover:text-primary-700">
            {article.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {article.excerpt}
        </p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" aria-hidden="true"></i>
            {formatCount(article.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-thumb-up-line" aria-hidden="true"></i>
            {formatCount(article.likes)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-3-line" aria-hidden="true"></i>
            {formatCount(article.comments)}
          </span>
        </div>
      </div>
    </article>
  );
}